"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconSuvFilled = function IconSuvFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.4231 24.9018L38.6972 22.7619C38.2325 22.464 29.4297 21.4035 29.4297 21.4035L27.2888 18.5556C27.2361 18.4451 27.1549 18.3506 27.0535 18.282C26.952 18.2134 26.8341 18.1731 26.7119 18.1654C24.3119 18.1098 12.1031 17.8119 11.9731 18.1843C11.3962 19.7472 10.2979 23.7689 10 25.3675L10.6881 28.4944C10.7508 28.7086 10.8811 28.8968 11.0596 29.0309C11.2381 29.1649 11.4551 29.2376 11.6783 29.2381H13.2517C13.2917 30.2218 13.7106 31.1518 14.4207 31.8336C15.1308 32.5154 16.0771 32.8962 17.0615 32.8962C18.046 32.8962 18.9923 32.5154 19.7024 31.8336C20.4125 31.1518 20.8313 30.2218 20.8713 29.2381H30.4042C30.4442 30.2218 30.8631 31.1518 31.5732 31.8336C32.2833 32.5154 33.2295 32.8962 34.214 32.8962C35.1984 32.8962 36.1447 32.5154 36.8548 31.8336C37.5649 31.1518 37.9838 30.2218 38.0238 29.2381H38.3615C38.5854 29.2423 38.8042 29.1714 38.983 29.0365C39.1617 28.9017 39.2901 28.7108 39.3476 28.4944L40 26.7259V24.9018H39.4231ZM17.0626 31.335C16.4937 31.334 15.9465 31.1167 15.532 30.7271C15.1175 30.3375 14.8666 29.8048 14.8304 29.2371C14.8304 29.1899 14.8231 29.1416 14.8231 29.0934C14.8166 28.7951 14.8698 28.4986 14.9795 28.2212C15.0891 27.9438 15.2531 27.691 15.4617 27.4778C15.6704 27.2646 15.9195 27.0952 16.1945 26.9796C16.4695 26.8639 16.7648 26.8043 17.0631 26.8043C17.3614 26.8043 17.6567 26.8639 17.9317 26.9796C18.2067 27.0952 18.4558 27.2646 18.6645 27.4778C18.8731 27.691 19.0371 27.9438 19.1468 28.2212C19.2564 28.4986 19.3096 28.7951 19.3031 29.0934C19.3031 29.1416 19.3031 29.1899 19.2958 29.2371C19.2591 29.8048 19.008 30.3374 18.5933 30.7269C18.1787 31.1164 17.6315 31.3338 17.0626 31.335V31.335ZM34.215 31.335C33.6461 31.3338 33.0989 31.1164 32.6843 30.7269C32.2696 30.3374 32.0185 29.8048 31.9818 29.2371C31.9818 29.1899 31.9745 29.1416 31.9745 29.0934C31.9745 28.4991 32.2105 27.9292 32.6307 27.5091C33.0509 27.0889 33.6208 26.8528 34.215 26.8528C34.8093 26.8528 35.3792 27.0889 35.7993 27.5091C36.2195 27.9292 36.4556 28.4991 36.4556 29.0934C36.4556 29.1416 36.4556 29.1899 36.4483 29.2371C36.4115 29.8048 36.1604 30.3374 35.7458 30.7269C35.3311 31.1164 34.7839 31.3338 34.215 31.335V31.335Z",
    fill: color
  }));
};

IconSuvFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconSuvFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconSuvFilled;
exports.default = _default;